__turbopack_context__.v({
  "Cont": "TextPage-module-sass-module__VFMYxW__Cont",
  "Copy": "TextPage-module-sass-module__VFMYxW__Copy",
  "TextPage": "TextPage-module-sass-module__VFMYxW__TextPage",
});
